import AboutUsPage from "../pages/AboutUsPage/AboutUsPage";
import CategoryPage from "../pages/CategoryPage/CategoryPage";
import CheckoutPage from "../pages/CheckoutPage/CheckoutPage";
import CollectionPage from "../pages/CollectionPage/CollectionPage";
import FinalPaymentPage from "../pages/FinalPaymentPage/FinalPaymentPage";
import GiftPage from "../pages/GiftPage/GiftPage";
import Home from "../pages/Home/Home";
import OrderInfoPage from "../pages/OrderInfoPage/OrderInfoPage";
import ProductDetail from "../pages/ProductDetail/ProductDetail";
import ProfilePage from "../pages/ProfilePage/ProfilePage";
import ResetPasswordHandler from "../components/ResetPasswordHandler/ResetPasswordHandler";
import NotFoundPage from "../pages/erroPage/notFoundPage";
import ServicesPage from "../pages/ServicesPage/ServicesPage";
import SupportPage from "../pages/SupportPage/SupportPage";

const publicRoutes = [
  { path: "/", component: Home },
  { path: "/products/category/:category", component: CategoryPage },
  { path: "/product-detail/:id/:slugName", component: ProductDetail },
  { path: "/products/category", component: CollectionPage },
  { path: "/about-us", component: AboutUsPage },
  { path: "/gifts", component: GiftPage },
  { path: "/reset-password", component: ResetPasswordHandler },
  { path: "/support", component: SupportPage },
  { path: "/services", component: ServicesPage },
  // Guest checkout routes — backend hỗ trợ customer_id: 0 (Phase 02-06)
  { path: "/checkout", component: CheckoutPage },
  { path: "/checkout/order-info", component: OrderInfoPage },
  { path: "/final-payment", component: FinalPaymentPage },
  { path: "/404", component: NotFoundPage },
  { path: "*", component: NotFoundPage }, // Catch-all route for 404
];

const privateRoutes = [
  // Profile là account-only — giữ nguyên guard
  { path: "/profile", component: ProfilePage },
];

export { publicRoutes, privateRoutes };
